
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// 懒加载页面组件
const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const OverviewPage = lazy(() => import('../pages/overview/page'));
const ManufacturerListPage = lazy(() => import('../pages/manufacturer/list/page'));
const SupplierListPage = lazy(() => import('../pages/supplier/list/page'));
const ModelListPage = lazy(() => import('../pages/model/list/page'));
const ModelResourcePage = lazy(() => import('../pages/model/resource/page'));
const CategoryListPage = lazy(() => import('../pages/category/list/page'));
const ParameterListPage = lazy(() => import('../pages/parameter/list/page'));
const SeriesListPage = lazy(() => import('../pages/series/list/page'));
const UserListPage = lazy(() => import('../pages/user/list/page'));
const UserAuthPage = lazy(() => import('../pages/user/auth/page'));
const UserLevelPage = lazy(() => import('../pages/user/level/page'));
const OrderListPage = lazy(() => import('../pages/order/list/page'));
const OrderAfterSalesPage = lazy(() => import('../pages/order/after-sales/page'));
const DataConsumptionPage = lazy(() => import('../pages/data/consumption/page'));
const DataCallPage = lazy(() => import('../pages/data/call/page'));
const SystemPaymentPage = lazy(() => import('../pages/system/payment/page'));
const SystemLogPage = lazy(() => import('../pages/system/log/page'));
const PermissionRolePage = lazy(() => import('../pages/permission/role/page'));
const PermissionUserPage = lazy(() => import('../pages/permission/user/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <OverviewPage />,
  },
  {
    path: '/home',
    element: <HomePage />,
  },
  {
    path: '/overview',
    element: <OverviewPage />,
  },
  {
    path: '/manufacturer/list',
    element: <ManufacturerListPage />,
  },
  {
    path: '/supplier/list',
    element: <SupplierListPage />,
  },
  {
    path: '/model/list',
    element: <ModelListPage />,
  },
  {
    path: '/model/resource',
    element: <ModelResourcePage />,
  },
  {
    path: '/category/list',
    element: <CategoryListPage />,
  },
  {
    path: '/parameter/list',
    element: <ParameterListPage />,
  },
  {
    path: '/series/list',
    element: <SeriesListPage />,
  },
  {
    path: '/user/list',
    element: <UserListPage />,
  },
  {
    path: '/user/auth',
    element: <UserAuthPage />,
  },
  {
    path: '/user/level',
    element: <UserLevelPage />,
  },
  {
    path: '/order/list',
    element: <OrderListPage />,
  },
  {
    path: '/order/after-sales',
    element: <OrderAfterSalesPage />,
  },
  {
    path: '/data/consumption',
    element: <DataConsumptionPage />,
  },
  {
    path: '/data/call',
    element: <DataCallPage />,
  },
  {
    path: '/system/payment',
    element: <SystemPaymentPage />,
  },
  {
    path: '/system/log',
    element: <SystemLogPage />,
  },
  {
    path: '/permission/role',
    element: <PermissionRolePage />,
  },
  {
    path: '/permission/user',
    element: <PermissionUserPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
